import React, { useEffect, useRef, useState } from "react";
import { MapPin } from "lucide-react";
const OurLocation = () => {
  const [activeOffice, setActiveOffice] = useState("kl");
  const maps = {
    kl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3983.924706532796!2d101.66063657581327!3d3.1146222533621626!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31cc49804710101f%3A0x3acf785b204ce088!2sMenara%20SuezCap!5e0!3m2!1sen!2sin!4v1786598946862!5m2!1sen!2sin",
    trichy:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3919.8372582301654!2d78.71143727428725!3d10.747022959736942!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3baa8b54ea666bb5%3A0xcb242ac9808f183!2sMorais%20Global%20Hub!5e0!3m2!1sen!2sin!4v1786555912321!5m2!1sen!2sin&hl=en&z=15&output=embed",
  };
  return (
    <section className="bg-white pt-6 pb-0 w-full">
      <div className="text-center px-4 sm:px-6 md:px-10 lg:px-20 mb-10 max-w-screen-xl mx-auto">
        <h2 className="text-4xl font-bold text-[#1c1c1c] mb-4">Our location</h2>
        <p className="text-lg text-[#3d3d3d]">
          Feel free to visit our office to learn more about our products, services, and work culture.
        </p>
      </div>
      <section className="font-['Epilogue'] flex flex-col lg:flex-row w-full max-w-7xl mx-auto bg-white rounded-3xl overflow-hidden shadow-lg border border-gray-100 my-10">
        <div className="flex flex-col justify-center p-10 lg:w-[45%] bg-white space-y-8">
          <div
            onClick={() => setActiveOffice("kl")}
            className={`flex items-start cursor-pointer transition-all duration-300 p-4 rounded-2xl ${activeOffice === "kl"
              ? "bg-blue-50 border-l-4 border-blue-600"
              : "hover:bg-gray-50"
              }`}
          >
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-blue-100 text-blue-700 mr-4">
              <MapPin size={26} />
            </div>
            <div>
              <h2 className="text-lg md:text-xl lg:text-2xl font-semibold text-blue-800 leading-snug">
                Jalan Kerinchi, Kuala Lumpur – Headquarters
              </h2>
              <p className="mt-3 text-gray-700 text-sm md:text-base leading-relaxed">
                D-23A-3A, Menara SuezCap, KL Gateway, <br />
                Jalan Kerinchi, Pantai Dalam, <br />
                59200 Kuala Lumpur, Malaysia
              </p>
            </div>
          </div>
          <div
            onClick={() => setActiveOffice("trichy")}
            className={`flex items-start cursor-pointer transition-all duration-300 p-4 rounded-2xl ${activeOffice === "trichy"
              ? "bg-blue-50 border-l-4 border-blue-600"
              : "hover:bg-gray-50"
              }`}
          >
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-blue-100 text-blue-700 mr-4">
              <MapPin size={26} />
            </div>
            <div>
              <h2 className="text-lg md:text-xl lg:text-2xl font-semibold text-blue-800 leading-snug">
                Trichy Office – India
              </h2>
              <p className="mt-3 text-gray-700 text-sm md:text-base leading-relaxed">
                Morais Global Hub, G04, F01-1 West Wing, <br />
                Morais City, Thirunagar, Tiruchirappalli,<br />
                Tamil Nadu, INDIA 620007
              </p>
            </div>
          </div>
        </div>
        <div className="lg:w-[55%] w-full h-[350px] lg:h-[500px] overflow-hidden">
          <iframe
            title="Office Location Map"
            src={activeOffice === "kl" ? maps.kl : maps.trichy}
            className="w-full h-full border-0"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>
    </section>
  );
};

export default OurLocation;